import { Link } from 'react-router-dom';

import PageWrapper from '@/components/atoms/PageWrapper';
import { Button } from '@/components/ui/button';

import { BorderBox } from '@/components/atoms/BorderBox';
import { Label } from '@/components/ui/label';
import { Separator } from '@/components/ui/separator';
import { useRouteError } from "react-router-dom";
import * as Sentry from '@sentry/react'
import { useEffect } from 'react';

export function ErrorBoundaryPage() {
    const error = useRouteError() as { message?: string };
    useEffect(() => {
        Sentry.captureException(error)
    }, [error])
    return (
        <PageWrapper className="flex-col justify-between gap-4 mx-auto">
            <div className='flex flex-col gap-4'>
                <h1 className='font-black text-7xl text-primary'>Oops...</h1>
                <div className="mb-1 text-4xl font-bold text-primary">Something went wrong!</div>
                <Separator />
            </div>
            <div className="flex flex-col max-w-2xl gap-4 mx-auto">
                <Label className="text-xl font-black text-red-500">
                    Error:
                </Label>
                <BorderBox
                    variant='danger'
                    className='w-auto p-8'
                    iconProps={{
                        size: 24,
                    }}>
                    {error?.message}
                </BorderBox>
            </div>
            <div className="flex justify-end">
                <Link to="/">
                    <Button className="w-full sm:w-auto">Go back to homepage</Button>
                </Link>
            </div>
        </PageWrapper>
    )
}
